import { render, staticRenderFns } from "./EcAbout.vue?vue&type=template&id=4f5f27e9&scoped=true"
import script from "./EcAbout.vue?vue&type=script&lang=js"
export * from "./EcAbout.vue?vue&type=script&lang=js"
import style0 from "./EcAbout.vue?vue&type=style&index=0&id=4f5f27e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f27e9",
  null
  
)

export default component.exports